export const CAPTION_ABOVE = "Above";
export const CAPTION_BELOW = "Below";
export const ALIGNMENT_LEFT = "Left";
export const ALIGNMENT_CENTER = "Center";
export const ALIGNMENT_RIGHT = "Right";
